var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 73,
    viewBox: "0 0 341 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 73V73.5H0H341H341.5V73V4V2.41321L340.59 3.71336C335.387 11.1499 324.628 19.1386 309.267 25.1253C293.919 31.107 274.017 35.0736 250.578 34.5001C221.266 33.783 193.165 26.9458 168.945 20.2757C164.914 19.1656 160.988 18.0596 157.182 16.9871C149.563 14.8404 142.422 12.8284 135.872 11.1887C126.052 8.73042 117.503 7.09361 110.595 7.09361C102.594 7.09361 95.0803 9.09037 87.4923 11.5078C85.7504 12.0627 84.0057 12.6393 82.25 13.2196C76.3394 15.1731 70.3047 17.1676 63.8357 18.5128C47.1188 21.9889 27.5236 21.1176 0.270578 3.57954L-0.5 3.08365V4V73Z",
    fill: "url(#paint0_linear_2547_2377)",
    stroke: "#FF5151"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2547_2377",
    x1: 170.5,
    y1: 15,
    x2: 170.038,
    y2: 83.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5151",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStats);
export default __webpack_public_path__ + "static/media/redStats.41284779bafbb17726b14f6acbdcb443.svg";
export { ForwardRef as ReactComponent };